module.exports = __webpack_public_path__ + "static/media/audit.3d9fe80d.svg";